import React, { useState, useEffect } from 'react'
import './SignUp.scss'
import Input from '../../components/Input/Input'
import CheckBox from '../../components/Input/CheckBox'
import Button from '../../components/Button/Button'
import toast, { Toaster } from 'react-hot-toast';
import { Navigate } from 'react-router-dom';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import logo from '../../assets/logosnowcamp.png'
import emailjs from "@emailjs/browser";
import { KEY } from '../../utils/Const'
import Title from '../../components/Title/Title'
import Footer from '../../components/Footer/Footer'
import moment from 'moment'

const firebaseConfig = {
  apiKey: "AIzaSyC1BE8O5HQJ6VQcHU-29djLySMJvIC8OCQ",
  authDomain: "bookingsnowcamp.firebaseapp.com",
  databaseURL: "https://bookingsnowcamp-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "bookingsnowcamp",
  storageBucket: "bookingsnowcamp.appspot.com",
  messagingSenderId: "394603355230",
  appId: "1:394603355230:web:b5e36ae8485e76d8e168cf",
  measurementId: "G-YC4N5NZH76"
};

firebase.initializeApp(firebaseConfig)


// Initialize Cloud Firestore and get a reference to the service
const db = firebase.firestore();

const SignUp = () => {
  const [success, setSuccess] = useState(false);
  const [sex, setSex] = useState();
  const [date, setDate] = useState();
  const now = new Date();
  const [phone, setPhone] = useState();
  const errorToast = {
    style: {
      borderRadius: '10px',
      background: '#EAEFC8',
      color: '#005452',
    }
  }

  useEffect(() => {
    emailjs.init(KEY.apiKey)
  }, []);


  const handleDate = (date) => {
    if (isNaN(parseInt(date.charAt(date.length - 1)))) {
      setDate(date.slice(0, date.length - 1))
    } else {
      if (date.length === 2 && !date.includes("/")) {
        setDate(date + "/")
      } else if (date.length === 5 && date.charAt(5) !== "/") {
        setDate(date + "/")
      } else {
        setDate(date);
      }
      if (date.length > 10) {
        setDate(date.slice(0, 10))
      }
    }
  }

  const handlePhone = (phone) => {
    if (isNaN(parseInt(phone.charAt(phone.length - 1))) && phone.charAt(phone.length - 1) !== "+") {
      setPhone(phone.slice(0, phone.length - 1))
    } else {
      setPhone(phone.slice(0, 15))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(document.getElementById('email').value)) {
      return toast.error("Email non corretta", errorToast);
    }
    let fields = document.getElementsByTagName('input').length;
    let isCorrect = true;
    for (let i = 0; i < fields; i++) {
      if (document.getElementsByTagName('input')[i].value === "" &&
        (document.getElementsByTagName('input')[i].id !== "allergy" &&
          document.getElementsByTagName('input')[i].id !== "room")
      ) {
        isCorrect = false;
      }
    }
    if (!isCorrect) {
      return toast.error("Compilare tutti i campi", errorToast);
    } else {
      let data = {}
      for (let i = 0; i < fields; i++) {
        if (document.getElementsByTagName('input')[i].id !== "female" &&
          document.getElementsByTagName('input')[i].id !== "male" &&
          document.getElementsByTagName('input')[i].id !== "si" &&
          document.getElementsByTagName('input')[i].id !== "no") {
          data[document.getElementsByTagName('input')[i].id] = document.getElementsByTagName('input')[i].value;
        }
      }
      data.sex = sex;
      // data.date = moment(now.getTime()).format('DD/MM/YYYY HH:mm:ss');
      data.date = Date.now();
      console.log(data);
      db.collection("guests").add(data)
        .then((docRef) => {
          emailjs.send(KEY.confirmEmailService, KEY.confirmEmailTemplate, { to_name: data.name, to_email: data.email })
            .then(response => console.log(response))
            .catch(error => console.log(error))
          setSuccess(true);
          console.log("Document written with ID: ", docRef.id);
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
          toast.error("Qualcosa è andato storto vi invitiamo a riprovare più tardi", errorToast);
        });
    }
  }

  return (
    <>

      <div className='singUp-container'>
        {/* <img src={logo} alt="" /> */}
        {success && <Navigate to="/done" replace={true} />}
        <Toaster position='top-right' />
        <Title>Iscriviti ora!</Title>
        <form onSubmit={handleSubmit}>
          <div className='signup'>
            <div className='row'>
              <Input placeholder="Nome" type="text" id="name" />
              <Input placeholder="Cognome" type="text" id="surname" />
            </div>
            <div className='row'>
              <CheckBox value="M" id="male" checked={sex === "M"} onChange={(e) => setSex(e.target.value)} /><label htmlFor="male" className='check'>Maschio</label>
              <CheckBox value="F" id="female" checked={sex === "F"} onChange={(e) => setSex(e.target.value)} /><label htmlFor="female" className='check'>Femmina</label>
            </div>
            <div className='row'>
              <Input placeholder="Cellulare" type="text" id="phone" onChange={(e) => { handlePhone(e.target.value) }} value={phone} />
              <Input placeholder="Email" type="text" id="email" />
            </div>
            <div className='row'>
              <Input placeholder="Data di Nascita" type="text" id="birth" onChange={(e) => { handleDate(e.target.value) }} value={date} />
              <Input placeholder="Luogo di nascita" type="text" id="birthCity" />
            </div>
            <div className='row'>
              <Input placeholder="Indirizzo di residenza" type="text" id="address" />
              <Input placeholder="Intolleranze alimentari" type="text" id="allergy" />
            </div>
            <div className='row'>
              <Input placeholder="Preferenza stanza" type="text" id="room" />
            </div>
            <div className='row'>
              <Button type="submit">Invia</Button>
            </div>
          </div>
        </form>
      </div>
      <Footer />
    </>
  )
}

export default SignUp
